import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import "./sass/main.scss";

import Home from "./container/home/Home";

import Single from "./container/single/Single";
import Login from "./components/pages/Login/Login";
import Error from "./components/pages/error/SectionError";
import AdminPanel from "./components/pages/Admin/AdminPanel";

const PrivateRouter = ({ children, redirectTo }) => {
  const isAuthenticated = localStorage.getItem("isAuth") !== null;
  console.log("isAth:", isAuthenticated);
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route
        path="/home"
        element={
          <PrivateRouter redirectTo="/">
            <Home />
          </PrivateRouter>
        }
      />

      <Route
        path="/obra/:obra"
        element={
          <PrivateRouter redirectTo="/">
            <Single />
          </PrivateRouter>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRouter redirectTo="/">
            <AdminPanel />
          </PrivateRouter>
        }
      />
      <Route path="/" element={<Login />} />
      <Route path="/error" element={<Error />} />
      {/* <Route path="/obras/:obras" element={<Single />} /> */}
    </Routes>
  </BrowserRouter>,
);
